import { MosaicTocSectionClass } from "./MosaicTocSectionClass";
import type { IMosaicTocExpanded } from "./interface";

/**
 * Rebuilds entry ToC numbers from the current section structure.
 *
 * @param state - The current expanded ToC state.
 * @returns The updated ToC state with reassigned entry numbering.
 */
export const toc_reassignTocNumbers = (state: IMosaicTocExpanded): IMosaicTocExpanded => {
  const newState: IMosaicTocExpanded = { ...state };

  newState.tocItems = newState.tocItems.sort(
    (first, second) =>
      (first.tocOrder ??
        // istanbul ignore next -- ToC items should already have a numeric order.
        0) -
      (second.tocOrder ??
        // istanbul ignore next -- ToC items should already have a numeric order.
        0),
  );
  let lastSection = "";
  let lastNumber = 0;
  newState.tocItems = newState.tocItems.map((item) => {
    if (item instanceof MosaicTocSectionClass) {
      lastSection = item.tocNumber;
      lastNumber = 0;
      return item;
    }

    lastNumber++;
    const newTocNumber = lastSection !== "" ? `${lastSection}.${lastNumber}` : "";
    if (newTocNumber !== item.tocNumber) {
      return {
        ...item,
        tocNumber: newTocNumber,
        changed: true,
        inError: false,
      };
    }

    return item;
  });
  newState.saving = true;

  return newState;
};
